"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoredPcbCommand = exports.RemovePcbRuleSetsCommand = exports.UpdatePcbRuleSetsCommand = exports.AddPcbRuleSetsCommand = exports.RemovePcbNodesCommand = exports.UpdatePcbNodesCommand = exports.AddPcbNodesCommand = void 0;
const zod_1 = require("zod");
const common_1 = require("../../document/command/common");
const node_1 = require("../node");
const rule_1 = require("../rule");
/**
 * Adds one or more pcb nodes to document
 */
exports.AddPcbNodesCommand = zod_1.z.object({
    ...common_1.BaseCommand.shape,
    type: zod_1.z.literal(common_1.CommandType.addPcbNodesCommand),
    nodes: zod_1.z.union([zod_1.z.record(zod_1.z.string(), node_1.StoredPcbLayoutNodeSchema), zod_1.z.array(node_1.StoredPcbLayoutNodeSchema)]),
    skipSort: zod_1.z.boolean().optional(),
});
/**
 * Updates one or more pcb nodes to document
 */
exports.UpdatePcbNodesCommand = zod_1.z.object({
    ...common_1.BaseCommand.shape,
    type: zod_1.z.literal(common_1.CommandType.updatePcbNodesCommand),
    nodes: zod_1.z.union([zod_1.z.record(zod_1.z.string(), node_1.StoredPcbLayoutNodeSchema), zod_1.z.array(node_1.StoredPcbLayoutNodeSchema)]),
});
/**
 * Remove one or more pcb nodes from document
 */
exports.RemovePcbNodesCommand = zod_1.z.object({
    ...common_1.BaseCommand.shape,
    type: zod_1.z.literal(common_1.CommandType.removePcbNodesCommand),
    nodeUids: zod_1.z.array(zod_1.z.string()),
});
exports.AddPcbRuleSetsCommand = zod_1.z.object({
    ...common_1.BaseCommand.shape,
    type: zod_1.z.literal(common_1.CommandType.addPcbRuleSetsCommand),
    ruleSets: zod_1.z.union([zod_1.z.record(zod_1.z.string(), rule_1.StoredPcbLayoutRuleSetSchema), zod_1.z.array(rule_1.StoredPcbLayoutRuleSetSchema)]),
});
exports.UpdatePcbRuleSetsCommand = zod_1.z.object({
    ...common_1.BaseCommand.shape,
    type: zod_1.z.literal(common_1.CommandType.updatePcbRuleSetsCommand),
    ruleSets: zod_1.z.union([zod_1.z.record(zod_1.z.string(), rule_1.StoredPcbLayoutRuleSetSchema), zod_1.z.array(rule_1.StoredPcbLayoutRuleSetSchema)]),
});
exports.RemovePcbRuleSetsCommand = zod_1.z.object({
    ...common_1.BaseCommand.shape,
    type: zod_1.z.literal(common_1.CommandType.removePcbRuleSetsCommand),
    ruleSetUids: zod_1.z.array(zod_1.z.string()),
});
exports.StoredPcbCommand = zod_1.z.discriminatedUnion("type", [
    exports.AddPcbNodesCommand,
    exports.UpdatePcbNodesCommand,
    exports.RemovePcbNodesCommand,
    exports.AddPcbRuleSetsCommand,
    exports.UpdatePcbRuleSetsCommand,
    exports.RemovePcbRuleSetsCommand,
]);
//# sourceMappingURL=models.js.map